module.exports = __webpack_public_path__ + "assets/img/202112-6W.9d9f4f56.png";